import type { OrderSuppliesEpisodeCategory } from '@common/interfaces/orderSuppliesEpisodeCategory';
import type { OrderSuppliesSupplyCategory } from '@common/interfaces/orderSuppliesSupplyCategory';
import type { OrderSuppliesSupplyCategoryAttributes } from '@common/interfaces/orderSuppliesSupplyCategoryAttributes';
import { EpisodeCategory } from '@common/enums';

export const supplyCategoriesByEpisodeCategory: Record<
    OrderSuppliesEpisodeCategory,
    Partial<Record<OrderSuppliesSupplyCategory, OrderSuppliesSupplyCategoryAttributes>>
> = {
    [EpisodeCategory.cardiology]: {
        bittiumCable: {
            image: '/assets/images/orderSupplies/cardiology/bittium-cable@2x.jpg',
            label: 'Bittium elektrode 3-lead kabel',
            orderName: 'Order: Bittium-electrode-3-lead-kabel',
            path: 'bittiumCable',
            products: [
                {
                    image: '/assets/images/orderSupplies/cardiology/bittium-cable@2x.jpg',
                    label: 'Bittium elektrode 3-lead kabel',
                    value: 'bittium-cable',
                },
            ],
            selectionMode: 'single',
        },
        ecgElectrodes: {
            amount: [1, 2, 5, 10, 20],
            image: '/assets/images/orderSupplies/cardiology/ecg-electrodes@2x.jpg',
            label: 'Elektrodes voor ECG-apparatuur',
            orderName: 'Order rust-ECG',
            path: 'ecgElectrodes',
            products: [
                {
                    description: ['50 plakkers', '€ 10,73'],
                    image: '/assets/images/orderSupplies/cardiology/ecg-electrodes/swaromed@2x.jpg',
                    label: 'Swaromed Stekker',
                    value: 'swaromed',
                },
                {
                    description: ['50 plakkers', '€ 14,57'],
                    image: '/assets/images/orderSupplies/cardiology/ecg-electrodes/ambu@2x.jpg',
                    label: 'Ambu Blue Stekker',
                    value: 'ambu',
                },
                {
                    description: ['50 plakkers', '€ 4,74'],
                    image: '/assets/images/orderSupplies/cardiology/ecg-electrodes/henry@2x.jpg',
                    label: 'Henry Schein Drukknop',
                    value: 'henry',
                },
            ],
            selectionMode: 'single',
        },
        holterAccessories: {
            image: '/assets/images/orderSupplies/cardiology/holter-accessories@2x.jpg',
            label: 'Holterbenodigdheden (plakkers en tasjes)',
            orderName: 'Order: {selectedProduct}',
            path: 'holterAccessories',
            products: [
                {
                    description: ['20 stuks', '15 tasjes'],
                    image: '/assets/images/orderSupplies/cardiology/holter-accessories/holter-white@2x.jpg',
                    label: 'Witte holter',
                    value: 'wit-20',
                },
                {
                    description: ['3 elektroden', '50 plakkers (2 zakjes)'],
                    image: '/assets/images/orderSupplies/cardiology/holter-accessories/holter-black-3@2x.jpg',
                    label: 'Zwarte holter',
                    value: 'zwart-3',
                },
                {
                    description: ['5 elektroden', '50 plakkers (10 zakjes)'],
                    image: '/assets/images/orderSupplies/cardiology/holter-accessories/holter-black-5@2x.jpg',
                    label: 'Zwarte holter',
                    value: 'zwart-5',
                },
                {
                    description: ['anti-allergeen', '10 plakkers (2 zakjes)'],
                    image: '/assets/images/orderSupplies/cardiology/holter-accessories/holter-black-antiallergic@2x.jpg',
                    label: 'Zwarte holter',
                    value: 'zwart-anti-allergeen',
                },
            ],
            selectionMode: 'single',
        },
    },
    [EpisodeCategory.ophthalmology]: {
        eyeDropRecordCards: {
            label: 'Druppelkaartjes',
            orderName: 'Order Druppelkaartjes',
            path: 'eyeDropRecordCards',
            products: [
                {
                    label: '100 druppelkaartjes',
                    value: 'eye-drop-cards',
                },
            ],
            selectionMode: 'single',
        },
    },
    [EpisodeCategory.allergology]: {
        respiratoryAllergy: {
            hasDeliveryLocation: true,
            label: 'Luchtwegallergie',
            orderName: 'Order Luchtwegallergie',
            path: 'respiratoryAllergy',
            products: [
                {
                    label: 'Set van allergenen en 2 controle vloeistoffen',
                    value: 'allergen-set',
                },
                {
                    label: 'Priktestnaalden (200 stuks)',
                    value: 'prick-test-needles',
                },
                {
                    label: 'Kwaddelmeter',
                    value: 'wheal-meter',
                },
                {
                    label: 'Tapehouder',
                    value: 'tape-holder',
                },
                {
                    label: 'Blanco tape (1,25 cm breed)',
                    value: 'tape-125',
                },
                {
                    label: 'Blanco tape (2,50 cm breed)',
                    value: 'tape-250',
                },
                {
                    label: 'Huidschrijfpen',
                    value: 'skin-marker',
                },
            ],
            selectionMode: 'multiple',
        },
    },
    [EpisodeCategory.general]: {
        hardwareToken: {
            label: 'Hardware token',
            orderName: 'Order hardware token',
            path: 'hardwareToken',
            products: [
                {
                    label: 'Hardware token',
                    value: 'hardware-token',
                },
            ],
            selectionMode: 'single',
        },
    },
} as const;
